<!-- commonTitle -->
<template>
  <div
    :class="['commonTitle', { inApp: ($root.$data.isApp && !isAPPShow) || (this.$root.miniprogram) }]"
    :style="{ background: bcColor, zIndex }"
  >
    <button @click="goBack" v-if="back" class="backButton"></button>
    <p class="titleName text-overflow">{{ titleName }}</p>
    <slot name="btnSty"> </slot>
  </div>
</template>

<script>
export default {
  props: {
    titleName: {
      type: String,
      default: '',
    },
    back: {
      type: Boolean,
      default: true,
    },
    bcColor: {
      type: String,
      default: '#FFF',
    },
    zIndex: {
      type: Number,
      default: 10000,
    },
    beforeExec: {
      type: Function,
      default: () => {},
    },
    routerJumpParam: {
      type: [Object, String],
      default: () => {},
    },
    isAPPShow: {
      // 是否在APP内显示
      type: Boolean,
      default: false,
    },
    goHome: {
      // 顶部返回是否返回首页
      type: Boolean,
      default: false,
    },
    isDone: {
      // 入学任务页是否全部做完 如果做完go(-1) 否则 go(-2)
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      routerFrom: '',
    };
  },

  methods: {
    goBack() {
      if (this.$root.$data.isApp && this.$route.query.back === 'back') {
        window.history.go(-1);
        return;
      }
      if (this.$root.$data.isApp) {
        this.$sendToApp('closePage');
        return;
      }
      if (this.$route.name === 'bilibiliOrderResult') {
        this.$router.push({
          path: `/bilibili-shipments/1${window.location.search}`,
        });
        return;
      }
      if (this.$route.name === 'entranceTask' && !this.isDone) {
        window.history.go(-2);
        return;
      }
      if (this.$route.name === 'myIndent') {
        this.$router.push({
          path: '/personalCenter/Index',
        });
        sessionStorage.removeItem('routerJumpParam');
        return;
      }
      if (this.$route.name === 'myHandsel') {
        this.$router.push({
          path: '/personalCenter/myIndent',
        });
        return;
      }
      if (this.$route.name === 'handselDetail') {
        this.$router.push({
          path: '/personalCenter/myHandsel',
        });
        return;
      }
      if (this.$route.name === 'groupProgress' || this.$route.name === 'address') {
        this.$emit('goBack');
        return;
      }
      if (this.$route.name === 'indentDetail') {
        if (
          // eslint-disable-next-line operator-linebreak
          this.routerJumpParam.from?.name === 'myIndent' ||
          sessionStorage.getItem('routerJumpParam') === 'myIndent'
        ) {
          window.history.go(-1);
          return;
        }
        if (this.routerJumpParam) {
          const { combinationId, productId } = this.routerJumpParam;
          if (combinationId) {
            this.$router.push({
              path: '/combinationCourse',
              query: {
                combinationId,
              },
            });
            return;
          }
          this.$router.push({
            path: '/courseDetail',
            query: {
              courseId: productId,
            },
          });
        }
        return;
      }
      if (this.$route.path === '/personalCenter/mycourseList' || this.goHome) {
        this.$router.push({
          path: '/commonExamYear',
          query: {
            code: 13,
          },
        });
        return;
      }
      if (this.$route.name === 'record' || this.$route.name === 'projectDetail') {
        this.$emit('goBack');
        return;
      }
      if (this.$route.path === '/shoppingCar') {
        this.$router.back();
        return;
      }
      if (
        this.$route.path === '/personalCenter/returnClass' &&
        !this.$route.fullPath.includes('type')
      ) {
        this.$router.push({
          path: '/',
        });
        return;
      }
      console.log('333333333-------')
      console.log(this.$route.path)
      if (this.$route.path.includes('/schoolChoose')) {
        this.$router.push({path: '/personalCenter/member'});
        return;
      }
      if (this.beforeExec() === false) return;
      window.history.go(-1);
    },
  },
};
</script>

<style lang="scss">
.commonTitle {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  font-size: 36px;
  line-height: 100px;
  text-align: center;
  background: #ffff;

  &.inApp {
    display: none;
  }

  .backButton {
    position: absolute;
    top: 28.5px;
    left: 31px;
    width: 43px;
    height: 43px;
    background: url('../../assets/img/header/back-button.png') no-repeat center;
    background-size: contain;
  }

  .titleName {
    padding-right: 200px;
    padding-left: 200px;
    font-weight: 400;
  }
}
</style>
